import React, { useContext, useEffect, useState } from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaPencilAlt, FaTrash } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { BrcContext } from "../BrcContextWrapper";
import { AlertDismissable } from "../components/Alerts";
import AnswerForm from "../components/AnswerForm";
import DataTable from "../components/datatable";
import PopUpModal from "../components/PopUpModal";
import { deleteAnswer, getAnswerByQuestion } from "../service/brc";

const Answer = () => {

  const { show, toggleShow, deleteShow, toggleDelete, isEdit, toggleIsEdit, sessionUser} = useContext(BrcContext);
  const [answers, setAnswers] = useState([]);

  const [pending, setPending] = useState(true);

  const navigate = useNavigate();

  const { state } = useLocation();

  const [currentAnswerToDelete, setcurrentAnswerToDelete] = useState();
  const [deleteError, setDeleteError] = useState('');

  const handleClose = () => toggleDelete();
  const handleShow = (e) => {
    toggleShow();
  };
  const [selectedRow, setSelectedRow] = useState("");

  const customStyles = {
    headCells: {
      style: {
        float: "right ",
        backgroundColor: " #cccccc",
        fontWeight: "bold",
        fontSize: "13px",
      },
    },
  };

  let columns = [
      {
        name: "Answer",
        selector: (row) => row.answer,
      },
      {
        name: "Preferred",
        selector: (row) => (row.isCorrect ? "Yes" : "No"),
      },
      {
        name: "Responses",
        selector: (row) => row.count,
        sortable: true,
        center: true,
      },
      {
        name: "Responses(Control)",
        selector: (row) => row.controlCount,
        center: true,
      },
      {
        name: "Responses(Exposed)",
        selector: (row) => row.exposedCount,
        center: true,
      },
      sessionUser && sessionUser.isAdmin
        ? {
            name: "Actions",
            selector: (row) => (
              <div>
                <OverlayTrigger placement="top" overlay={<Tooltip>Edit</Tooltip>}>
                  <Button variant="primary" size="sm" onClick={() => editHandler(row)}>
                    <FaPencilAlt />
                  </Button>
                </OverlayTrigger>{" "}
                <OverlayTrigger placement="top" overlay={<Tooltip>Delete</Tooltip>}>
                  <Button variant="danger" size="sm" onClick={() => deleteHandler(row)}>
                    <FaTrash />
                  </Button>
                </OverlayTrigger>
              </div>
            ),
            width: "300px",
            center: true,
          }
        : "",
    ],
    data = answers.map((item) => ({
      id: item._id,
      questionId: item.questionId,
      answer: item.answer,
      isCorrect: item.isCorrect,
      count: item.count,
      controlCount: item.controlCount,
      exposedCount: item.exposedCount
    }));

  const deleteHandler = (state) => {
      setcurrentAnswerToDelete(state.id);
      toggleDelete();
    },
    deleteObject = () => {
      let reqData = {
        email: sessionUser.email
      };
      deleteAnswer(reqData, currentAnswerToDelete).then((response) => {
        toggleDelete();
        // A rejected delete (e.g. the question's only preferred answer) must not read as a success.
        setDeleteError(response?.data?._status === true ? '' : response?.data?._message ?? 'Unknown Error!');
        loadAnswers();
      });
    },
    editHandler = (state) => {
      setSelectedRow({
        id: state.id,
        questionId: state.questionId,
        answer: state.answer,
        isCorrect: state.isCorrect
      });
      toggleIsEdit(true);
      handleShow();
    },
    createHandler = () => {
      if (data.length <= 5) {
        setSelectedRow({
          id: "",
          questionId: state.id,
          answer: "",
          isCorrect: false
        });
        toggleIsEdit(false);
        handleShow();
      } else {
        alert("You can create only 6 answer");
      }
    },
    returnToQuestions = () => {
      navigate("/Questions", { state: state });
    },
    userCheck = async () => {
      if (!sessionUser || !sessionUser.email) {
        navigate("/Login");
        window.location.reload();
      }
    };

  const loadAnswers = () => {
    getAnswerByQuestion(state.id).then((res) => {
      setAnswers(res.data._data.reverse());
      setPending(false);
    });
  }

  useEffect(() => {
    userCheck();
    if (state == undefined || state == null || state == "") {
      navigate("/");
    } else {
      loadAnswers();
    }
  }, []);
  return (
    <div>
      <PopUpModal deleteText="answer" deleteShow={deleteShow} handleClose={handleClose} deleteObject={deleteObject}></PopUpModal>
      <AlertDismissable
        dismiss={() => setDeleteError('')}
        show={!!deleteError}
        message={deleteError}
        type="error"
      />
      <Button
        style={{
          fontWeight: "bold",
          margin: "10px",
          float: "left",
        }}
        variant="secondary"
        onClick={() => returnToQuestions()}
      >
        {" "}
        Return to Questions
      </Button>
      {sessionUser && sessionUser.isAdmin && (
        <Button
          style={{
            fontWeight: "bold",
            margin: "10px",
            float: "right",
          }}
          variant="primary"
          onClick={() => createHandler()}
        >
          Create Answer
        </Button>
      )}
      <AnswerForm
        show={show}
        setShow={toggleShow}
        isEdit={isEdit}
        id={selectedRow.id}
        questionId={selectedRow.questionId}
        answer={selectedRow.answer}
        isCorrect={selectedRow.isCorrect}
        sessionUser={sessionUser}
        loadAnswers={loadAnswers}
      />
      {<DataTable title={`${state ? state.question : ""}'s Answers`} columns={columns} data={data} customStyles={customStyles} progressPending={pending}/>}
    </div>
  );
};

export default Answer;
